<template>
    <div>
        <Breadcrumbs main="Admin" submain="Resources" title="Relief" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Relief</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="relief_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(name)="row">
                                            <div v-if="row.item.name">
                                                <p>{{ row.item.name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(unit)="row">
                                            <div v-if="row.item.unit">
                                                <p>{{ row.item.unit }}</p>
                                            </div>
                                        </template>

                                        <template #cell(amount)="row">
                                            <div v-if="row.item.amount">
                                                <p>{{ row.item.amount }}</p>
                                            </div>
                                        </template>

                                        <template #cell(type)="row">
                                            <div v-if="row.item.type">
                                                <span v-if="row.item.type == 'adult'" style="text-transform: capitalize; background-color: #00984a; color: white; padding: 4px 8px; border-radius: 0.375rem;">Adult</span>
                                                <span v-else-if="row.item.type == 'child'" style="text-transform: capitalize; background-color: #007bff; color: white; padding: 4px 8px; border-radius: 0.375rem;">Child</span>
                                                <span v-else-if="row.item.type == 'pregnant'" style="text-transform: capitalize; background-color: #f42a6b; color: white; padding: 4px 8px; border-radius: 0.375rem;">Pregnant</span>
                                                <span v-else-if="row.item.type == 'sick'" style="text-transform: capitalize; background-color: #2c323f; color: white; padding: 4px 8px; border-radius: 0.375rem;">Sick</span>
                                                <span v-else-if="row.item.type == 'menstruation'" style="text-transform: capitalize; background-color: #6c757d; color: white; padding: 4px 8px; border-radius: 0.375rem;">Menstruation</span>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteRelief(data.item.id)" title="Delete"></feather>
                                                </div>
    
                                                <div @click="editRelief(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Relief Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Relief" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter relief name" v-model="relief.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Unit</label>
                            <input class="form-control" type="text" placeholder="Enter unit" v-model="relief.unit">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Amount</label>
                            <input class="form-control" type="number" placeholder="Enter amount" v-model="relief.amount">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Type</label>
                            <select class="form-control digits" v-model="relief.type">
                                <option selected disabled>Select a type</option>
                                <option v-for="(type, index) in types" :key="index" :value="type.value">{{ type.title }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Relief Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Relief" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter relief name" v-model="edit_relief.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Unit</label>
                            <input class="form-control" type="text" placeholder="Enter relief number" v-model="edit_relief.unit">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Amount</label>
                            <input class="form-control" type="number" placeholder="Enter relief number" v-model="edit_relief.amount">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Type</label>
                            <select class="form-control digits" v-model="edit_relief.type">
                                <option selected disabled>Select a type</option>
                                <option v-for="(type, index) in types" :key="index" :value="type.value">{{ type.title }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Relief Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this relief?</div>
        </b-modal>
    </div>
</template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            loader
        },
    
        data() {
            return {
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'unit',
                        label: 'Unit',
                        sortable: true
                    },
                    {
                        key: 'amount',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'type',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],

                types: [
                    {
                        title: 'Adult',
                        value: 'adult'
                    },
                    {
                        title: 'Child',
                        value: 'child'
                    },
                    {
                        title: 'Pregnant',
                        value: 'pregnant'
                    },
                    {
                        title: 'Menstruation',
                        value: 'menstruation'
                    },
                    {
                        title: 'Sick',
                        value: 'sick'
                    },
                ],
    
                relief: {
                    name: null,
                    unit: null,
                    amount: null,
                    type: null
                },
    
                edit_relief: {
                    id: null,
                    name: null,
                    unit: null,
                    amount: null,
                    type: null
                },
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                relief_list: state => state.relief.relief_list,
                loading: state => state.relief.reliefLoading,
                error: state => state.relief.reliefError
            }),
    
            sortOptions() {
                // Create an options list from our fields
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("relief/fetchRelief").then(() => {
                this.items = this.relief_list
                this.totalRows = this.relief_list.length;
            });
        },
    
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.relief.name = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("relief/addRelief", {
                    relief: this.relief
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.relief.name = null
                        this.relief.unit = null
                        this.relief.amount = null
                        this.relief.type = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editRelief(detail) {
                this.edit_relief.id = detail.id ? detail.id : null
                this.edit_relief.name = detail.name ? detail.name : null
                this.edit_relief.unit = detail.unit ? detail.unit : null
                this.edit_relief.amount = detail.amount ? detail.amount : null
                this.edit_relief.type = detail.type ? detail.type : null
            },
    
            resetEditModal() {
                this.edit_relief.name = null
                this.edit_relief.unit = null
                this.edit_relief.amount = null
                this.edit_relief.type = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("relief/updateRelief", {
                    id: this.edit_relief.id,
                    relief: this.edit_relief
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.edit_relief.name = null
                        this.edit_relief.unit = null
                        this.edit_relief.amount = null
                        this.edit_relief.type = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteRelief(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("relief/deleteRelief", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    